export default {
	methods: {
		checkUrl(domain, query){
			let searchapi =''
			if (window.location.host.includes('staging')) {
				searchapi = `https://${domain}.staging.webmd.com`;
			} else if (window.location.host.includes('qa') || window.location.host.includes('localhost')){
				searchapi = `https://${domain}.staging.webmd.com`;
			} else {
				searchapi = `https://${domain}.webmd.com`;
			}
			return searchapi+query;
		},
		clickOutSide(targetID, targetFunction){
			if(document){
				const popupDiv = document.getElementById(targetID);
				document.addEventListener('click', (event)=>{  
					const clickedElement = event.target;
					event.stopPropagation();  
					if ((clickedElement !== popupDiv && !clickedElement.matches('a')  && !popupDiv.contains(clickedElement)) && (Array.from(event.target.classList).length==0  || (Array.from(event.target.classList).length>0 && !Array.from(event.target.classList).includes('bookmark-icon')))){
						targetFunction()
					}	
				});
			}
		},
		checkWebUrl(query){
			let searchapi =''
			if (window.location.host.includes('staging')) {
				searchapi = `https://member.staging.webmd.com`;
			} else if (window.location.host.includes('qa')){
				searchapi = `https://member.qa.webmd.com`;
			} else {
				searchapi = `https://member.webmd.com`;
			}
			return searchapi+query;
		},
		popupAction(module, displayValue, desktopScreen){
			if(module=='reg-login'){
				if(desktopScreen){
					this.$vwmdPageLink({moduleName: `reg-login2_crtacct2`});
				}
				else if(this.getCookie('ab')){
					this.$vwmdPageLink({moduleName: (displayValue) ? `reg-login2b_crtacct2b` : `reg-login2a_crtacct2a`});
				}
				else{
					this.$vwmdPageLink({moduleName: `reg-login2_crtacct2`});
				}
				this.$emit('updateAction', 'register')
			}
			else{
				if(desktopScreen){
					this.$vwmdPageLink({moduleName: `reg-create2_signin2`});
				}
				else if(this.getCookie('ab')){
					this.$vwmdPageLink({moduleName: (displayValue) ? `reg-create2b_signin2b` : `reg-create2a_signin2a`});
				}
				else{
					this.$vwmdPageLink({moduleName: `reg-create2_signin2`});
				}
				this.$emit('updateAction', 'login')
			}
		},
		updateUrl(getUrl, getData){
			let urlMain = '';
			if(this.$route?.query?.returl) {
				if(this.$route.query.returl === 'https://www.webmd.com' || this.$route.query.returl === 'https://www.webmd.com/default.htm') {
					if(getData){
						urlMain = `${getUrl}?data=${getData}`
					}
					else{
						urlMain = getUrl
					}
				}
				else if(getData){
					urlMain = `${getUrl}?returl=${this.$route.query.returl}&data=${getData}`
				}
				else{
					urlMain = `${getUrl}?returl=${this.$route.query.returl}`
				}
			}
			else if(getData){
				urlMain = `${getUrl}?data=${getData}`
			}
			else{
				urlMain = getUrl
			}

			if(typeof this.$route?.query?.redirectUrl != 'undefined'){
				urlMain = urlMain.includes('?') ? `${urlMain}&redirectUrl=${this.$route.query.redirectUrl}` :` ${urlMain}?redirectUrl=${this.$route.query.redirectUrl}`
			}
			return this.checkWebUrl(urlMain);
		},
        omnitureCall(pageMbName, moduleName){
			let pageUrl = window.location.origin;
			if(moduleName){
				this.$vwmdDpv({ pageName: `${pageUrl}/${pageMbName}`, moduleName:moduleName, refresh: false });
			}
			else{
				this.$vwmdDpv({ pageName: `${pageUrl}/${pageMbName}`, refresh: false });
			}
		},
        omniturePage(mmodule, mlink) {
            this.$vwmdTrack({ moduleName: `${mmodule}_${mlink}`});
        },
		getCookie(cookieName) {
			let initName = cookieName + "=";
			let decodedWDCookie = decodeURIComponent(document.cookie);
			let wdCookie = decodedWDCookie.split(';');
			for (let initLoop = 0; initLoop < wdCookie.length; initLoop++) {
				let getCookie = wdCookie[initLoop];
				while (getCookie.charAt(0) == ' ') {
					getCookie = getCookie.substring(1);
				}
				if (getCookie.indexOf(initName) == 0) {
					return getCookie.substring(initName.length, getCookie.length);
				}
			}
			return "";
		},
		checkValue(str, max) {
			if (str.charAt(0) !== '0' || str == '00') {
				var num = parseInt(str);
				if (isNaN(num) || num <= 0 || num > max) num = 1;
				str = num > parseInt(max.toString().charAt(0)) && num.toString().length == 1 ? '0' + num : num.toString();
			};
			return str;
		},

		autoFormateData(event, name, displayerror){
			var input = this.formData['dob'];
			if (/\D\/$/.test(input)) input = input.substr(0, input.length - 3);
			var values = input.split('/').map(function(v) {
				return v.replace(/\D/g, '')
			});
			if (values[0]) values[0] = this.checkValue(values[0], 12);
			if (values[1]) values[1] = this.checkValue(values[1], 31);
			var output = values.map(function(v, i) {
				return v.length == 2 && i < 2 ? v + ' / ' : v;
			});
			this.formData['dob'] = output.join('').substr(0, 14);
			this.inputCheck(event, name, displayerror)
		},

		regErrorMessage(code, email){
			let errorMessage = {
				'RegisterUser input validation failed': `<span>The email address and password you entered don't match any WebMD account. Please try again.</span>`,
				'Invalid Email Address Password combination' : '<span>Your combination of email address and birthdate is incorrect.</span>',
				'User does not exist' : `<span>Either your combination of email address and birthdate is incorrect or the user does not exist.</span>`,
				'User Already Exists' : '<span>This email is already connected to an account.</span>',
				'30' : 'used',
				'-701' :"<span>The email address and password you entered don't match any WebMD account. Please try again. </span>",
				'-1':"<span>The email address and password you entered don't match any WebMD account. Please try again. </span>",
				'0': "<span>There was a problem logging in. Please try again later</span>",
				'-702':"<span>The email address and password you entered don't match any WebMD account. Please try again. </span>",
				'-707':`<span>If there’s a WebMD account associated with ${email} you’ll get a link in your inbox to reset your password. </span>`,
			}
			return errorMessage[code];
		},

		validatedate(dateString){
			dateString = dateString.split(' / ').join('/')

			let dateformat = /^(0?[1-9]|1[0-2])[\/](0?[1-9]|[1-2][0-9]|3[01])[\/]\d{4}$/;
			if(dateString.match(dateformat)){
				let operator = dateString.split('/');
				let datepart = [];
				if (operator.length>1){
					datepart = dateString.split('/');
				}
				let month= parseInt(datepart[0]);
				let day = parseInt(datepart[1]);
				let year = parseInt(datepart[2]);
				let ListofDays = [31,28,31,30,31,30,31,31,30,31,30,31];
				if((year< (new Date().getFullYear()-120)) || (year > (new Date().getFullYear()))){
					return false;
				}
				if (month==1 || month>2){
					if (day>ListofDays[month-1]){
						return false;
					}
				}
				if (month==2){
					let leapYear = false;
					if ( (!(year % 4) && year % 100) || !(year % 400)) {
						leapYear = true;
					}
					if ((leapYear == false) && (day>=29)){
						return false;
					}
					else if ((leapYear==true) && (day>29)){
						return false;
					}
				}
			}
			else{
				return false;
			}
			return true;
		},
		deleteCookie(cookieName) {
			const cookieValue = this.$vreadCookie(cookieName);
			if (cookieValue) {
				this.$vdeleteCookie(cookieName);
			}
		},
    }
}